// sf-preview-bridge v1
//
// Next.js runs this file in the browser before the app hydrates. It only
// starts the site-factory preview bridge (lib/preview/bridge.ts), which does
// nothing outside a factory preview.
import { reportPreviewRoute, startPreviewBridge } from "./lib/preview/bridge";

startPreviewBridge();

// A client navigation begins (Link, router.push/replace, back/forward).
// Reported now so the workspace follows at the click, not seconds later when
// the dev server has compiled the page; the bridge corrects it if the router
// lands somewhere else.
export function onRouterTransitionStart(url: string): void {
  reportPreviewRoute(url);
}
